import React, {useEffect, useState} from 'react';
import {getNewInvoiceOrdersCount} from "./_redux/newInvoiceOrdersCountActions";
import styles from './styles.module.scss';

const NewInvoiceOrdersCount = () => {
  const [count, setCount] = useState(0);
  const handleGetCount = () => {
    Promise.resolve()
      .then(() => getNewInvoiceOrdersCount())
      .then(setCount)
      .catch(err => {
        console.error(err);
        setCount(0);
      })
  };

  useEffect(() => {
    handleGetCount();
    const interval = setInterval(() => {
      handleGetCount();
    }, 180000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className={styles.container}>
      <div className={styles.count}>
        {count > 99999 ? '+99999' : count}
      </div>
    </div>
  );
};

export default NewInvoiceOrdersCount;
